/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */

// eslint-disable-next-line fp/no-class
export class OAuthError extends Error {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  constructor(public error: string, public error_description?: string) {
    super(error_description || error);
  }
}
